export default function Footer() {
  const columns = [
    {
      title: '栏目',
      links: [
        { label: '现场直击', href: '#live' },
        { label: '热点热榜', href: '#hot' },
        { label: '红毯生图', href: '#gallery' },
        { label: '综艺名场面', href: '#moment' },
      ],
    },
    {
      title: '关于',
      links: [
        { label: '栏目介绍', href: '#about' },
        { label: '内容原则', href: '#faq' },
        { label: '加入讨论', href: '#faq' },
      ],
    },
  ];

  return (
    <footer id="about" className="border-t border-background-200 bg-accent-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-md">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-600 text-background-50">
                <i className="ri-camera-3-line text-xl"></i>
              </span>
              <span className="font-heading text-2xl font-black text-foreground-950">
                明星吃瓜<span className="text-primary-600">现场</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-6 text-foreground-700">
              专注记录公开活动现场与已官宣娱乐动态的资讯小站。红毯生图、综艺名场面、热剧动态，一手汇总，让你不用在多平台来回翻找，就能看齐最新瓜点。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-foreground-300/50 text-foreground-800 transition-colors hover:bg-background-50">
                <i className="ri-weibo-line text-base"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-foreground-300/50 text-foreground-800 transition-colors hover:bg-background-50">
                <i className="ri-douban-line text-base"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-foreground-300/50 text-foreground-800 transition-colors hover:bg-background-50">
                <i className="ri-mail-line text-base"></i>
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:gap-16">
            {columns.map((col) => (
              <div key={col.title}>
                <h4 className="text-xs font-bold uppercase tracking-[0.24em] text-foreground-600">{col.title}</h4>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <a href={l.href} className="text-[15px] text-foreground-800 transition-colors hover:text-primary-700">
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="max-w-xs">
            <h4 className="text-xs font-bold uppercase tracking-[0.24em] text-foreground-600">栏目定位</h4>
            <p className="mt-4 text-sm leading-6 text-foreground-700">
              以娱乐为镜，看真实现场。我们坚持客观报道公开活动，不放大情绪、不编造花边，让吃瓜这件事回归轻松与分寸。
            </p>
            <a
              href="#subscribe"
              className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
            >
              订阅速递 <i className="ri-send-plane-line text-sm"></i>
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-foreground-300/40 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-700">
            © 2026 明星吃瓜现场 · 内容仅作娱乐信息整理，来源以公开活动与官方动态为准
          </p>
          <p className="flex items-center gap-1 text-xs text-foreground-600">
            <i className="ri-leaf-line"></i> 理性吃瓜 · 文明冲浪
          </p>
        </div>
      </div>
    </footer>
  );
}